import Logo from "./logo/logo.png";
import Verizon from "./logo/verizon.svg";

const ImageAssets = {
  logo: Logo,
  verizon: Verizon,
};

export default ImageAssets;
